import {investments_api} from '@/store/resources'

export default {
    namespaced: true,
    state: {
        assets_list: {
            data: [],
            dirty: false
        }
    },
    getters: {},
    actions: {
        searchInstrument({}, payload) {
            return investments_api.search_instrument.get({q: payload.query, type: payload.type});
        },
        addSymbol({}, ticker) {
            return investments_api.add_search_instrument.save({ticker});
        }
    },
    mutations: {}
}